import { render, staticRenderFns } from "./ProjectSeo.vue?vue&type=template&id=158a99bd"
import script from "./ProjectSeo.vue?vue&type=script&lang=js"
export * from "./ProjectSeo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports